module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'lj32l72g',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
